import { render, staticRenderFns } from "./IdentificationForm.vue?vue&type=template&id=a995999e&scoped=true&"
import script from "./IdentificationForm.vue?vue&type=script&lang=js&"
export * from "./IdentificationForm.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationForm.vue?vue&type=style&index=0&id=a995999e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a995999e",
  null
  
)

export default component.exports